import {apsDisplayEnums} from "../../shared/dto/enums";
import * as angular from 'angular';
import {LineCounts, LineEquipmentGroup} from "../../models/counts/lineCounts";
import CountsServiceName, {CountsService} from "./counts.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import EquipmentGroupRejectsName, {openEquipmentGroupRejects} from "../../controllers/counts/equipmentGroupRejects.controller";

let requires = [CountsServiceName, LoaderServiceName, EquipmentGroupRejectsName];

export interface GroupRejectsService {
  showGroupRejects(
    data: EquipmentGroupRejectsServiceData
  ): void;
}

export interface EquipmentGroupRejectsServiceData {
  equipmentGroup: LineEquipmentGroup;
  shopId: string;
  lineCounts: LineCounts;
  countsInterval: apsDisplayEnums.CountDisplayInterval;
}

export default angular
  .module('aps.services.groupRejects', requires)
  .service('groupRejectsService', groupRejectsService)
  .name;

function groupRejectsService(
  $q: angular.IQService,
  $modal: mm.foundation.modal,
  countsService: CountsService,
  loaderService: LoaderService
): GroupRejectsService {

  function showGroupRejects(data: EquipmentGroupRejectsServiceData):
    void {
    let modalPromise: angular.IPromise<any> = $q.when();
    let hasTabs = false;
    let hasDetails = false;
    for (let key in data.equipmentGroup.equipment) {
      let equipment = data.equipmentGroup.equipment[key];
      if (equipment.hasTabs) {
        hasTabs = true;
        break;
      } else if (equipment.detailDataPoints && equipment.detailDataPoints.length > 0) {
        hasDetails = true;
        break;
      }
    }

    if (hasTabs || hasDetails) {
      modalPromise = countsService.getGroupEquipmentCounts(data.shopId, data.lineCounts, data.equipmentGroup, data.countsInterval)
        .then(counts => {
          data.lineCounts.currentDetailCounts = counts;
        });
      loaderService.loadingPromise(modalPromise);
    }

    modalPromise.then(() => {
      data.lineCounts.currentGroup = data.equipmentGroup;
      let result = openEquipmentGroupRejects({
        equipmentGroup: data.equipmentGroup,
        shopId: data.shopId,
        detail: data.lineCounts.currentDetailCounts,
        lines: data.lineCounts.lines,
        timeZoneId: data.lineCounts.shopConfig.timeZoneId
      }, $modal);

      result.then(() => {
        if (data.lineCounts.currentDetailCounts) {
          delete data.lineCounts.currentDetailCounts;
        }
        if (data.lineCounts.currentGroup) {
          if (data.lineCounts.currentGroup.rejects) {
            delete data.lineCounts.currentGroup.rejects;
          }
          data.lineCounts.currentGroup = null;
        }
      });
    });
  }

  return {
    showGroupRejects: showGroupRejects
  };
}


// WEBPACK FOOTER //
// ./src/app/services/counts/groupRejects.service.ts